import React from 'react';

class Progress extends React.Component{

    static defaultProps = {
        context: "primary",
        width: .10,
        striped: true,
        animated: false
    };
    
    render(){
        const { context, width, striped, animated } = this.props;
        return (
            <div className="progress">
              <div className={'progress-bar bg-'+context+' '+(striped?'progress-bar-striped':null)+' '+(animated?'progress-bar-animated':null)} role="progressbar" style={{width:(width*100)+'%'}}></div>
            </div>
        );
    }
}

export default Progress;
